import { createFileRoute } from '@tanstack/react-router'
import { SchoolDashboardClient } from '../components/SchoolDashboardClient'

export const Route = createFileRoute('/school/$schoolId/')({
  head: () => ({
    meta: [{ title: 'School Dashboard | Unbreakable' }],
  }),
  component: SchoolDashboardPage,
})

function SchoolDashboardPage() {
  return <SchoolDashboardClient />
}
